/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { PlayAppComponent } from './app/components/play-app/play-app.component'
import { playAppProviders } from './app/providers/play-app-providers'

bootstrapApplication(PlayAppComponent, playAppProviders).catch((err) =>
  console.error(err),
)
